<script lang="ts">
export default {
  name: 'ColorSwatch',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { XCircle } from '@lucide/vue';

const props = defineProps<{
  color: string;
  small?: boolean;
  rounded?: boolean;
  modelValue?: string;
  selected?: boolean;
  editable?: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
  remove: [value: string];
}>();

const sizeClass = computed(() => (props.small ? 'h-[26px] w-[26px] min-w-[26px]' : 'h-[32px] w-[32px] min-w-[32px]'));
const roundClass = computed(() => (props.rounded ? 'rounded-lg' : 'rounded'));

function handleClick(): void {
  emit('update:modelValue', props.color);
}

function handleRemove(): void {
  emit('remove', props.color);
}
</script>

<template>
  <div class="relative inline-block">
    <button
      type="button"
      :class="[
        sizeClass,
        roundClass,
        'border-2 border-solid p-0 transition-colors outline-none',
        selected ? 'border-gray-900 ring-1 ring-gray-400' : 'border-gray-400 hover:border-gray-500',
        'focus:ring-2 focus:ring-primary/50',
      ]"
      :style="{ backgroundColor: color }"
      @click="handleClick" />
    <button
      v-if="editable"
      type="button"
      class="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-gray-600 text-white opacity-90 hover:opacity-100"
      @click.stop="handleRemove">
      <XCircle :size="10" />
    </button>
  </div>
</template>
